import jwt from 'jwt-simple';

export default (payload = {}) => {
  const secret = Buffer.from('fe1a1915a379f3be5394b64d14794932', 'hex');
  const token = jwt.encode(payload, secret);

  return token;
};
